module.exports = __webpack_public_path__ + "static/media/dumbbellExplore.56f00fce.png";